import { Box } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import Points from "../elements/Points";
import { BaseQuizProps } from "../elements/Quiz/types";

type IProps = {
  xpPoints: BaseQuizProps["xpPoints"];
  showXpPoints: boolean;
};

const QuizXpPoint = ({ showXpPoints, xpPoints }: IProps) => {
  return (
    <Box>
      <AnimatePresence>
        {showXpPoints && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 10,
            }}
          >
            <Points value={xpPoints} />
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default QuizXpPoint;
